var baseStyle = {
  bg: 'blue.900',
  color: 'white'
};
export var Badge = {
  baseStyle
};